import React, { useState } from 'react';
import Sidebar from '../composants/SideBar/SideBar';
import UserInfo from '../composants/UserInfo/UserInfo';
import { useAuth } from '../contexts/AuthContext';
import './MainLayout.css';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const { user } = useAuth();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [unreadCommandes, setUnreadCommandes] = useState(0);

  // Add this prop to receive updates from Commandes component
  const handleNotificationUpdate = (count: number) => {
    setUnreadCommandes(count);
  };

  return (
    <div className="app-layout">
      <Sidebar
        userName={user?.name || ''}
        organisationName={user?.organisme || ''}
        onLogout={() => { }}
        unreadCommandes={unreadCommandes}
        isCollapsed={isSidebarCollapsed}
        onCollapse={setIsSidebarCollapsed}
      />
      <main className={`main-content ${isSidebarCollapsed ? 'sidebar-collapsed' : ''}`}>
        <UserInfo />
        {React.cloneElement(children as React.ReactElement, {
          onNotificationUpdate: handleNotificationUpdate
        })}
      </main>
    </div>
  );
};

export default MainLayout;